import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'app-cssd',
    templateUrl: './cssd.component.html',
    styleUrls: ['./cssd.component.css']
})
export class CssdComponent implements OnInit {
    xyz: any;

    constructor() {
    }

    ngOnInit() {
    }

    table1() {
        this.xyz = 0;
    }
    table2() {
        this.xyz = 1;
    }
}



// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/cssd/cssd.component.ts